import { createRouter, createWebHistory } from "vue-router";

import { admin_routes } from "./admin";
import { web_routes } from "./web";

const routes = [...admin_routes, ...web_routes];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.onError((error) => {
  const chunkFailedMsg = /Loading chunk .* failed|ChunkLoadError/i;
  if (chunkFailedMsg.test(error.message)) {
    if (!sessionStorage.getItem("chunk_reload")) {
      sessionStorage.setItem("chunk_reload", "1");
      window.location.reload();
    }
  }
});

router.afterEach(() => {
  sessionStorage.removeItem("chunk_reload");
});
